import { auth } from './firebaseAuth';
import type { FeedReaction } from './feedInteractions';

export async function feedRequest<T>(
  url: string,
  method = 'GET',
  body?: object,
  signal?: AbortSignal,
): Promise<T> {
  // Uygulama yeniden açılınca oturum depolamadan geri yüklenirken istek beklemeye alınır.
  if (!auth.currentUser) await auth.authStateReady();
  const user = auth.currentUser;
  if (!user) throw new Error('Giriş yapmalısın.');
  const token = await user.getIdToken();
  if (auth.currentUser?.uid !== user.uid || signal?.aborted) throw new Error('Oturum değişti.');
  const response = await fetch(url, {
    method,
    signal,
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body ? { 'Content-Type': 'application/json' } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (auth.currentUser?.uid !== user.uid) throw new Error('Oturum değişti.');
  if (!response.ok) throw new Error(String(response.status));
  return response.json();
}

export const readReactions = async (
  ids: string[],
  signal: AbortSignal,
): Promise<Record<string, FeedReaction>> => {
  const states: Record<string, FeedReaction> = {};
  for (let index = 0; index < ids.length; index += 50) {
    // eslint-disable-next-line no-await-in-loop -- sınırlı parçalar; paralel istek fırtınası oluşturma
    const batch = await feedRequest<Record<string, FeedReaction>>(
      '/api/feed-reactions',
      'POST',
      { eventIds: ids.slice(index, index + 50) },
      signal,
    );
    Object.assign(states, batch);
  }
  return states;
};
